export default [
  {
    title: 'verify-user',
    step: 1,
    subStep: 1,
    nextRoutes: {
      1: 'login',
      2: 'user-info',
    },
  },
  {
    title: 'login',
    step: 1,
    subStep: 1,
    nextRoutes: {
      1: 'user-address-mobile',
    },
  },
  {
    title: 'user-info',
    step: 1,
    subStep: 1,
    nextRoutes: {
      1: 'fill-user-info',
    },
  },
  {
    title: 'fill-user-info',
    step: 1,
    subStep: 1,
    nextRoutes: {
      1: 'user-address-mobile',
    },
  },
  {
    title: 'user-address-mobile',
    step: 1,
    subStep: 1,
    nextRoutes: {
      1: 'select-insurances-mobile',
    },
  },
  {
    title: 'select-insurances-mobile',
    step: 1,
    subStep: 2,
    nextRoutes: {
      1: 'risk-address-mobile',
      2: 'car-already-registered-mobile',
      3: 'health-information',
    },
  },
  {
    title: 'risk-address-mobile',
    step: 2,
    subStep: 0,
    nextRoutes: {
      1: 'risk-address-mortaged-mobile',
      2: 'address-to-insure',
    },
  },
  {
    title: 'risk-address-mortaged-mobile',
    step: 2,
    subStep: 1,
    nextRoutes: {
      1: 'homeowner',
    },
  },
  {
    title: 'homeowner',
    step: 2,
    subStep: 0,
    nextRoutes: {
      1: 'home-building-type',
    },
  },
  {
    title: 'address-to-insure',
    step: 2,
    subStep: 0,
    nextRoutes: {
      1: 'risk-address-mortaged-mobile',
    },
  },
  {
    title: 'home-building-type',
    step: 2,
    subStep: 1,
    nextRoutes: {
      1: 'home-surface-area',
    },
  },
  {
    title: 'home-surface-area',
    step: 2,
    subStep: 1,
    nextRoutes: {
      1: 'home-construction',
    },
  },
  // {
  //   title: 'home-information-extra-mobile',
  //   step: 2,
  //   subStep: 2,
  //   nextRoutes: {
  //     1: 'home-construction',
  //   },
  // },
  {
    title: 'home-construction',
    step: 2,
    subStep: 3,
    nextRoutes: {
      1: 'business-purpose-rooms',
    },
  },
  {
    title: 'home-renovation',
    step: 2,
    subStep: 3,
    nextRoutes: {
      1: 'business-purpose-rooms',
    },
  },
  // {
  //   title: 'home-extra-questions',
  //   step: 2,
  //   subStep: 3,
  //   nextRoutes: {
  //     1: 'business-purpose-rooms',
  //   },
  // },
  {
    title: 'business-purpose-rooms',
    step: 2,
    subStep: 3,
    nextRoutes: {
      1: 'property-insurance-policy-mobile',
    },
  },
  // {
  //   title: 'storage-unit',
  //   step: 2,
  //   subStep: 3,
  //   nextRoutes: {
  //     1: 'property-insurance-policy-mobile',
  //   },
  // },
  {
    title: 'property-insurance-policy-mobile',
    step: 2,
    subStep: 4,
    nextRoutes: {
      1: 'property-insurance-policy-information-mobile',
      2: 'property-insurance-extras',
    },
  },
  {
    title: 'property-insurance-policy-information-mobile',
    step: 2,
    subStep: 6,
    nextRoutes: {
      1: 'property-insurance-extras',
    },
  },
  {
    title: 'property-insurance-extras',
    step: 1,
    subStep: 7,
    nextRoutes: {
      1: 'home-specifics',
      2: 'property-insurance-extras-bike',
      3: 'property-insurance-extras-pets',
    },
  },
  {
    title: 'property-insurance-extras-pets',
    step: 2,
    subStep: 8,
    nextRoutes: {
      1: 'home-specifics',
    },
  },
  {
    title: 'property-insurance-extras-bike',
    step: 2,
    subStep: 7,
    nextRoutes: {
      1: 'home-specifics',
      2: 'property-insurance-extras-pets',
    },
  },
  {
    title: 'home-specifics',
    step: 2,
    subStep: 8,
    nextRoutes: {
      1: 'home-high-risk-mobile',
    },
  },
  {
    title: 'home-high-risk-mobile',
    step: 2,
    subStep: 9,
    nextRoutes: {
      1: 'insurance-options-home-mobile',
    },
  },
  {
    title: 'insurance-options-home-mobile',
    step: 2,
    subStep: 10,
    nextRoutes: {
      1: 'home-premium-summary-mobile',
    },
  },
  {
    title: 'home-premium-summary-mobile',
    step: 2,
    subStep: 11,
    nextRoutes: {
      1: 'second-risk-address-mobile',
      2: 'car-already-registered-mobile',
      3: 'health-information',
      4: 'overview',
    },
  },
  {
    title: 'second-risk-address-mobile',
    step: 2,
    subStep: 0,
    nextRoutes: {
      1: 'risk-address-mortaged-mobile',
    },
  },
  {
    title: 'car-already-registered-mobile',
    step: 3,
    subStep: 0,
    nextRoutes: {
      1: 'car-second-hand-mobile',
      2: 'license-lookup-response-mobile',
    },
  },
  {
    title: 'car-second-hand-mobile',
    step: 3,
    subStep: 1,
    nextRoutes: {
      1: 'car-lookup-mobile',
      2: 'license-plate-lookup-mobile',
    },
  },
  {
    title: 'car-lookup-mobile',
    step: 3,
    subStep: 2,
    nextRoutes: {
      1: 'replacement-vehicle-mobile',
    },
  },
  {
    title: 'license-plate-lookup-mobile',
    step: 3,
    subStep: 3,
    nextRoutes: {
      1: 'license-lookup-response-mobile',
    },
  },
  {
    title: 'license-lookup-response-mobile',
    step: 3,
    subStep: 4,
    nextRoutes: {
      1: 'replacement-vehicle-mobile',
    },
  },
  // {
  //   title: 'car-information-extra-mobile',
  //   step: 3,
  //   subStep: 4,
  //   nextRoutes: {
  //     1: 'replacement-vehicle-mobile',
  //   },
  // },
  {
    title: 'replacement-vehicle-mobile',
    step: 3,
    subStep: 5,
    nextRoutes: {
      1: 'vehicle-purpose-mobile',
    },
  },
  {
    title: 'vehicle-purpose-mobile',
    step: 3,
    subStep: 6,
    nextRoutes: {
      1: 'drivers-information-mobile',
    },
  },
  // {
  //   title: 'average-km-travelled-mobile',
  //   step: 3,
  //   subStep: 6,
  //   nextRoutes: {
  //     1: 'drivers-information-mobile',
  //   },
  // },
  {
    title: 'drivers-information-mobile',
    step: 3,
    subStep: 7,
    nextRoutes: {
      // 1: "drivers-information-extra-mobile"
      1: 'additional-drivers',
    },
  },
  {
    title: 'drivers-information-extra-mobile',
    step: 3,
    subStep: 8,
    nextRoutes: {
      1: 'drivers-policy-info',
    },
  },
  {
    title: 'additional-drivers',
    step: 3,
    subStep: 9,
    nextRoutes: {
      1: 'vehicle-insurance-policy-mobile',
    },
  },
  {
    title: 'vehicle-insurance-policy-mobile',
    step: 3,
    subStep: 10,
    nextRoutes: {
      1: 'vehicle-insurance-policy-information-mobile',
      2: 'vehicle-specifics',
    },
  },
  {
    title: 'vehicle-insurance-policy-information-mobile',
    step: 3,
    subStep: 11,
    nextRoutes: {
      1: 'vehicle-specifics',
    },
  },
  {
    title: 'vehicle-specifics',
    step: 3,
    subStep: 12,
    nextRoutes: {
      1: 'insurance-options-car-mobile',
    },
  },
  {
    title: 'insurance-options-car-mobile',
    step: 3,
    subStep: 13,
    nextRoutes: {
      1: 'car-premium-summary-mobile',
    },
  },
  {
    title: 'car-premium-summary-mobile',
    step: 3,
    subStep: 14,
    nextRoutes: {
      1: 'car-already-registered-mobile',
      2: 'health-information',
      3: 'overview',
    },
  },
  {
    title: 'health-information',
    step: 4,
    subStep: 0,
    nextRoutes: {
      1: 'doctor-information',
      2: 'blood-information',
      3: 'hba1c-test-information',
    },
  },
  {
    title: 'blood-information',
    step: 4,
    subStep: 1,
    nextRoutes: {
      1: 'doctor-information',
      2: 'hba1c-test-information',
    },
  },
  {
    title: 'hba1c-test-information',
    step: 4,
    subStep: 2,
    nextRoutes: {
      1: 'doctor-information',
    },
  },
  {
    title: 'doctor-information',
    step: 4,
    subStep: 3,
    nextRoutes: {
      1: 'parental-information',
    },
  },
  {
    title: 'parental-information',
    step: 4,
    subStep: 4,
    nextRoutes: {
      1: 'health-insurance-policy-mobile',
    },
  },
  {
    title: 'health-insurance-policy-mobile',
    step: 4,
    subStep: 5,
    nextRoutes: {
      1: 'health-insurance-policy-information-mobile',
      2: 'general-information',
      3: 'health-specifics',
    },
  },
  {
    title: 'health-insurance-policy-information-mobile',
    step: 4,
    subStep: 6,
    nextRoutes: {
      1: 'general-information',
    },
  },
  {
    title: 'general-information',
    step: 4,
    subStep: 7,
    nextRoutes: {
      1: 'health-specifics',
    },
  },
  {
    title: 'health-specifics',
    step: 4,
    subStep: 8,
    nextRoutes: {
      1: 'insurance-options-health-mobile',
    },
  },
  {
    title: 'insurance-options-health-mobile',
    step: 4,
    subStep: 9,
    nextRoutes: {
      1: 'health-premium-summary-mobile',
    },
  },
  {
    title: 'health-premium-summary-mobile',
    step: 4,
    subStep: 10,
    nextRoutes: {
      1: 'health-information',
      2: 'overview',
    },
  },
  {
    title: 'overview',
    step: 5,
    subStep: 0,
    nextRoutes: {
      1: 'thankyou',
    },
  },
  {
    title: 'thankyou',
    step: 5,
    subStep: 1,
    nextRoutes: {
      1: 'user-address',
    },
  },
];
